export const antdTheme = {
  token: {
    wireframe: false,
    colorPrimary: '#004615',
    colorInfo: '#004615',
    colorPrimaryBg: '#eaf2eb',
    colorText: 'rgba(0, 0, 0, 0.87)',
    colorTextHeading: '#2A2847',
    colorTextSecondary: 'rgba(0, 0, 0, 0.6)',
    colorBorder: '#B9B9C2',
    colorBorderSecondary: '#E8E8EB',
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#F5F6FA',
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, Satoshi, 'Satoshi-Variable'",
    fontWeightStrong: 700,
    fontSize: 14,
    borderRadius: 6,
    controlHeight: 32,
    lineWidth: 1,
  },
  components: {
    Alert: {
      colorInfo: '#1677ff',
      colorInfoBg: '#e6f4ff',
      colorInfoBorder: '#91caff',
    },
    Button: {
      colorPrimary: '#004615',
      primaryShadow: 'none',
      defaultBorderColor: '#B9B9C2',
      defaultColor: 'rgba(0, 0, 0, 0.87)',
      borderRadius: 6,
      controlHeight: 36,
      controlHeightLG: 42,
      controlHeightSM: 30,
      fontWeight: 400,
    },
    Card: {
      bodyPadding: 16,
    },
    Collapse: {
      headerBg: '#004615',
      colorTextHeading: '#FFFFFF',
    },
    Descriptions: {
      colorSplit: '#FFFFFF',
      lineWidth: 2,
    },
    Form: {
      labelColor: 'rgba(0, 0, 0, 0.87)',
      labelFontSize: 14,
      itemMarginBottom: 24,
    },
    Input: {
      colorBorder: '#d9d9d9',
      activeBorderColor: '#004615',
      hoverBorderColor: '#4F5863',
      colorText: 'rgba(0, 0, 0, 0.87)',
      colorTextPlaceholder: '#B9B9C2',
      activeShadow: 'none',
      borderRadius: 6,
      controlHeight: 32,
      paddingBlock: 4,
      paddingInline: 11,
    },
    InputNumber: {
      colorBorder: '#d9d9d9',
      activeBorderColor: '#004615',
      hoverBorderColor: '#4F5863',
      colorText: 'rgba(0, 0, 0, 0.87)',
      activeShadow: 'none',
      borderRadius: 6,
      controlHeight: 32,
    },
    Radio: {
      buttonBg: '#FFFFFF',
      buttonCheckedBg: '#004615',
      buttonColor: 'rgba(0, 0, 0, 0.87)',
      buttonSolidCheckedBg: '#004615',
      buttonSolidCheckedColor: '#FFFFFF',
      buttonSolidCheckedHoverBg: '#004615',
      colorBorder: '#B9B9C2',
    },
    Checkbox: {
      controlInteractiveSize: 18,
      borderRadiusSM: 4,
    },
    Select: {
      colorBorder: '#d9d9d9',
      colorText: 'rgba(0, 0, 0, 0.87)',
      controlHeight: 32,
      borderRadius: 6,
    },
    Typography: {
      colorTextHeading: '#2A2847',
      colorText: 'rgba(0, 0, 0, 0.87)',
      fontWeightStrong: 700,
    },
  },
};
